import * as React from 'react';
import CouponRegisterModal from './modal';
import SerasaRestrictionModal from './serasa-restriction-modal';
import CouponRegisterHook from './hook';
import { IBeneficiaryCouponRequest } from '../../interfaces/beneficiary';
import MaskedInput from 'react-maskedinput';
import ValidatorService from '../../services/validator-service';
import { FaCaretDown } from 'react-icons/fa'
import icon1 from '../../img/icon1.png';
import icon2 from '../../img/icon2.png';
import Loading from '../../components/loading';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';

interface FieldsValidation {
    beneficiaryId: boolean;
    coupom: boolean;
    product: boolean;
    cpf: boolean;
    crmNumber: boolean;
    crmState: boolean;
    bornDate: boolean;
    agreeTerm: boolean;
    [key: string]: boolean;
    cpfComprador: boolean;
}

export default function CouponRegisterPage() {
    const {
        states, getState,
        generalBenefit, getBenefit,
        products, getProducts,
        loadingProducts,
        subProducts, getSku,
        verifyCoupom, sendBeneficiaryCoupon,
        verifyEmployee,
        verifyFakePerson,
        sendBeneficiary, getBeneficiary,
        getPrescriber, sendBeneficiaryCpf
    } = CouponRegisterHook();

    const [invalidPrescriber, setInvalidPrescriber] = React.useState<boolean | null>(null);
    const [showInvalidCoupon, setShowInvalidCoupon] = React.useState<boolean | null>(null);
    const [messageInvalidCoupon, setMessageInvalidCoupon] = React.useState("");
    const [benefitId, setBenefitId] = React.useState(0);
    const [showSucess, setShowSucess] = React.useState(false);
    const [resetForm, setResetForm] = React.useState(false);
    const [resetSelect, setResetSelect] = React.useState(false);
    const formRef = React.useRef<HTMLFormElement | null>(null);
    const [showError, setShowError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("Número de CPF e/ou cupom inválidos");
    const [loading, setLoading] = React.useState(false);
    const [loadingCoupon, setLoadingCoupon] = React.useState(false);
    const [errorMessageConsult, setErrorMessageConsult] = React.useState<string | null>(null);
    const [errorMessageConsultBuyer, setErrorMessageConsultBuyer] = React.useState<string | null>(null);
    const [errorMessageConsultFake, setErrorMessageConsultFake] = React.useState<string | null>(null);
    const [errorMessageYoungerAge, setErrorMessageYoungerAge] = React.useState<string | null>(null);
    const [errorMessageConsultFakeBuyer, setErrorMessageConsultFakeBuyer] = React.useState<string | null>(null);
    const [errorMessageYoungerAgeBuyer, setErrorMessageYoungerAgeBuyer] = React.useState<string | null>(null);
    const [showSerasaRestriction, setShowSerasaRestriction] = React.useState(false);

    const [isCupomAttenzi, setIsCupomAttenzi] = React.useState(false);
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const [pendingProduct, setPendingProduct] = React.useState<{ id: number, productName: string | null } | null>(null);

    const [request, setRequest] = React.useState({
        beneficiaryId: 0,
        coupom: "",
        product: 0,
        cpf: "",
        crmNumber: "",
        crmState: "0",
        bornDate: "",
        agreeTerm: 0,
        cpfComprador: "",
        bornDateComprador: "",
        productDad: "",
        sku: 0
    } as IBeneficiaryCouponRequest);

    // validator
    const [fieldsInvalid, setFieldsInvalid] = React.useState<FieldsValidation>({
        beneficiaryId: false,
        coupom: false,
        product: false,
        cpf: false,
        crmNumber: false,
        crmState: false,
        bornDate: false,
        agreeTerm: false,
        cpfComprador: false,
        bornDateComprador: false,
        productDad: false
    });

    const validateAge = (dateString: string): boolean => {
        if (!dateString || dateString.length !== 10) return false;

        const today = new Date();
        const birthDate = new Date(dateString.split('/').reverse().join('-'));

        // Calcula a idade
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= 18;
    };

    const calculateAge = (dateString: string): number => {
        if (!dateString || dateString.length !== 10) return 0;

        const today = new Date();
        const birthDate = new Date(dateString.split('/').reverse().join('-'));

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    React.useEffect(() => { getState(); }, []);
    React.useEffect(() => { getBenefit(); }, []);
    React.useEffect(() => { validCoupon(); }, [request.coupom]);
    React.useEffect(() => { ValidEmployee(); }, [request.cpf]);
    React.useEffect(() => { ValidEmployeeBuyer(); }, [request.cpfComprador]);
    React.useEffect(() => { ValidFakePerson(); }, [request.bornDate]);
    React.useEffect(() => { ValidFakePersonBuyer(); }, [request.bornDateComprador]);
    React.useEffect(() => { validPrescriber(); }, [request.crmNumber, request.crmState]);
    React.useEffect(() => {
        if (products && products.length > 0 && !request.product) {
            setRequest(prevRequest => ({
                ...prevRequest,
                productDad: products[0].productName
            }));
        }

        if (products.length > 0 && String(products[0].productName) !== String(request.productDad)) {
            setRequest(prevRequest => ({
                ...prevRequest,
                productDad: products[0].productName
            }));
        }

        if (products && products.length > 0)
            setIsCupomAttenzi(true);
        else
            setIsCupomAttenzi(false);

        if (resetSelect) {
            setRequest(prevRequest => ({
                ...prevRequest,
                productDad: "0",
                product: 0,
                sku: 0
            }));
            setResetSelect(false);
        }
        // quando o usuário selecionar um produto válido, buscar os SKUs desse produto
        if (request.product && Number(request.product) > 0) {
            getSku(String(request.product));
            // resetar sku ao trocar o produto
            setRequest(prevRequest => ({ ...prevRequest, sku: 0 }));
        }
    }, [products, request.product]);

    const validPrescriber = async () => {
        if (request.crmState != "0" && request.crmNumber != "") {
            const result = await getPrescriber(request.crmState, request.crmNumber);
            setInvalidPrescriber(!result);
        }
    }

    const validCoupon = async () => {
        setRequest(prevRequest => ({ ...prevRequest, product: 0, sku: 0 }));
        if (request.coupom.length > 13) {
            setShowInvalidCoupon(false);
            setLoadingCoupon(true);

            const result = await verifyCoupom(request.coupom);

            let valid = false;
            let message = "";

            if (result.success) {
                setBenefitId(result.data.benefitId);
                valid = true;

                if (result.data.cpf != "") {
                    const response = await getBeneficiary(result.data.cpf, result.data.benefitId);

                    if (response.success) {
                        valid = false;

                        sendBeneficiaryCoupon({
                            cpf: result.data.cpf,
                            coupom: request.coupom,
                            beneficiaryId: response.data.id,
                            cpfComprador: result.data.cpfComprador
                        });

                        message = "Cupom já utilizado";
                    }
                }
            }
            else {
                message = result.messages ? result.messages[0].message : "";
            }

            setShowInvalidCoupon(!valid);
            setFieldsInvalid({ ...fieldsInvalid, coupom: !valid });
            setMessageInvalidCoupon(message);
            setLoadingCoupon(false);

            if (valid)
                getProducts(request.coupom);
        }
    }

    const ValidEmployee = async () => {
        setLoading(true);
        const cpfNumerico = request.cpf.replace(/\D/g, '');

        if (cpfNumerico.length === 11) {
            try {
                const result = await verifyEmployee(cpfNumerico);

                if (!result.success) {
                    setErrorMessageConsult(result.messages[0].message);
                } else {
                    setErrorMessageConsult('');
                }
            }
            catch (error) {
                setErrorMessageConsult("Erro ao consultar o CPF. Tente novamente.");
            }
        }
        setLoading(false);
    }

    const ValidEmployeeBuyer = async () => {
        setLoading(true);
        const cpfNumerico = request.cpfComprador.replace(/\D/g, '');

        if (cpfNumerico.length === 11) {
            try {
                const result = await verifyEmployee(cpfNumerico);

                if (!result.success) {
                    setErrorMessageConsultBuyer(result.messages[0].message);
                } else {
                    setErrorMessageConsultBuyer('');
                }
            }
            catch (error) {
                setErrorMessageConsultBuyer("Erro ao consultar o CPF. Tente novamente.");
            }
        }
        setLoading(false);
    }

    const ValidFakePerson = async () => {
        setLoading(true);
        const cpfNumerico = request.cpf.replace(/\D/g, '');

        const isDateComplete = (date: string) => {
            return date.length === 10 && !date.includes('_') && !date.includes(' ');
        };

        if (cpfNumerico.length === 11 && isDateComplete(request.bornDate)) {

            const age = calculateAge(request.bornDate);
            if (age < 18) {
                setErrorMessageYoungerAge("Paciente menor de idade - preencha os dados do comprador");
                setLoading(false);
                return;
            }

            try {
                setErrorMessageYoungerAge(null);
                const result = await verifyFakePerson(cpfNumerico, request.bornDate);

                if (!result.success) {
                    if (result.data?.serasaRestricted) {
                        setShowSerasaRestriction(true);
                    }
                    setErrorMessageConsultFake(result.messages?.[0]?.message || "Erro ao consultar. Tente novamente.");
                } else {
                    setErrorMessageConsultFake('');
                }
            }
            catch (error) {
                setErrorMessageConsultFake("Erro ao consultar. Tente novamente.");
            }
        }
        setLoading(false);
    }

    const ValidFakePersonBuyer = async () => {
        setLoading(true);
        const cpfNumerico = request.cpfComprador.replace(/\D/g, '');

        const isDateComplete = (date: string) => {
            return date.length === 10 && !date.includes('_') && !date.includes(' ');
        };

        if (cpfNumerico.length === 11 && isDateComplete(request.bornDateComprador)) {

            const age = calculateAge(request.bornDateComprador);
            if (age < 18) {
                setErrorMessageYoungerAgeBuyer("Comprador deve ser maior de idade.");
                setLoading(false);
                return;
            } else {
                setErrorMessageYoungerAge(null);
                setErrorMessageYoungerAgeBuyer(null);
            }

            try {
                const result = await verifyFakePerson(cpfNumerico, request.bornDateComprador);

                if (!result.success) {
                    setErrorMessageConsultFakeBuyer(result.messages?.[0]?.message || "Erro ao consultar. Tente novamente.");
                } else {
                    setErrorMessageConsultFakeBuyer('');
                }
            }
            catch (error) {
                setErrorMessageConsultFakeBuyer("Erro ao consultar. Tente novamente.");
            }
        }
        setLoading(false);
    }

    const validateCPF = (cpf: string) => {
        return ValidatorService().cpf(cpf);
    };

    const eventValidation = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | React.FocusEvent<HTMLSelectElement> | React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
        const toInt = parseInt(e.target.value);
        let value = e.target.value;

        if (toInt.toString() !== "NaN")
            fieldsInvalid[e.target.id] = !(toInt > 0);
        else
            fieldsInvalid[e.target.id] = !(e.target.value.length > 0);

        if (e.target.id === "cpf")
            fieldsInvalid.cpf = !validateCPF(e.target.value);
        else if (e.target.id === "cpfComprador")
            fieldsInvalid.cpfComprador = !validateCPF(e.target.value);
        else if (e.target.id === "crmState")
            fieldsInvalid[e.target.id] = e.target.value === "0";
        else if (e.target.id === "agreeTerm")
            value = (e.target as any).checked ? "1" : "0";
        else if (e.target.id === "bornDate" || e.target.id === "bornDateComprador") {
            const isDateComplete = e.target.value.length === 10 && !e.target.value.includes('_');
            fieldsInvalid[e.target.id] = !isDateComplete || !validateAge(e.target.value);
        }

        if (e.target.id === "product" && isCupomAttenzi && 
            value !== "0" && e.type !== 'focus') {
            const product = products.find(p => p.id.toString() === value);
            if (product) {
                setPendingProduct(product);
                setShowConfirmModal(true);
                setFieldsInvalid({ ...fieldsInvalid });
                return;
            }
        }

        setRequest({ ...request, [e.target.id]: value });
        setFieldsInvalid({ ...fieldsInvalid });
    }

    const handleConfirmSelection = () => {
        if (pendingProduct) {
            setRequest({ ...request, product: pendingProduct.id });
            setFieldsInvalid({ ...fieldsInvalid });
        }
        setShowConfirmModal(false);
        setPendingProduct(null);
    };

    const handleCancelSelection = () => {
        setRequest({ ...request, product: 0 });
        setFieldsInvalid({ ...fieldsInvalid });
        setShowConfirmModal(false);
        setPendingProduct(null);
    };

    const onSubmit = async (e: React.FormEvent<HTMLFormElement> | React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | React.FocusEvent<HTMLSelectElement> | React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        e.stopPropagation();

        request.cpfComprador = request.cpfComprador.replace(/\D/g, '');

        let valid = !showInvalidCoupon && request.agreeTerm == 1;

        if (
            errorMessageConsult ||
            errorMessageConsultBuyer ||
            errorMessageConsultFake ||
            errorMessageConsultFakeBuyer
        ) {
            return null;
        }

        if (
            request.agreeTerm === 0 ||
            request.crmState === null || request.crmState === "" ||
            request.crmNumber === null || request.crmNumber === "") {
            return null;
        }

        if (errorMessageYoungerAge !== null) {
            if (request.cpfComprador === null || request.cpfComprador === "" ||
                request.bornDateComprador === null || request.bornDateComprador === "") {
                setShowError(true);
                setErrorMessage("Dados do comprador são obrigatórios");
                return null;
            }
        }

        if (errorMessageYoungerAgeBuyer !== null) {
            setShowError(true);
            setErrorMessage("É necessário usuário adulto para continuar");
            return null;
        }

        if (valid) {
            setLoading(true);
            setShowError(false);
            setErrorMessage("");

            // insert
            let result = await sendBeneficiaryCoupon(request);
            if (result.success) {

                setShowSucess(true);
                setResetSelect(true);
                setRequest({
                    beneficiaryId: 0,
                    coupom: "",
                    product: 0,
                    cpf: "",
                    crmNumber: "",
                    crmState: "0",
                    bornDate: "",
                    agreeTerm: 0,
                    cpfComprador: "",
                    bornDateComprador: "",
                    sku: 0,
                    productDad: ""
                });

                setShowError(false);
                setErrorMessageConsultFake("");
                setErrorMessageConsultFakeBuyer("");
                setErrorMessage("");
                setErrorMessageConsult("");
                setErrorMessageConsultBuyer("");
                setShowSerasaRestriction(false);

                return setLoading(false);
            } else {
                setLoading(false);
                setShowError(true);

                if (result.messages != null && result.messages.length > 0)
                    setErrorMessage(result.messages[0].message);
            }
        }
    }

    let valid = !invalidPrescriber && !showInvalidCoupon && request.agreeTerm == 1;

    Object.keys(fieldsInvalid).filter(key => {
        if (fieldsInvalid[key])
            valid = false
    });

    return (
        <div className="header__form">
            <Link to="/" className="header__logo-1">
                <img src={icon2} alt="icon2" />
            </Link>
            <a href="#" className="header__logo-2">
                <img src={icon1} alt="" />
            </a>
            <p className="p-text">
                Preencha os dados abaixo para validar o seu cupom
            </p>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <input
                        id="coupom"
                        type="text"
                        placeholder="N° do cupom"
                        onChange={eventValidation}
                        onBlur={eventValidation}
                        className={fieldsInvalid.coupom ? "error" : ""}
                        value={request.coupom}
                        maxLength={15}
                    />
                    {
                        showInvalidCoupon &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {messageInvalidCoupon}
                        </span>
                    }
                    {
                        !showInvalidCoupon && loadingCoupon &&
                        <span className="text-primary" style={{ fontSize: "14px" }}>
                            Validando...
                        </span>
                    }
                </div>
                <div className="form-group">
                    <select
                        id="product"
                        onChange={eventValidation}
                        onFocus={eventValidation}
                        className={fieldsInvalid.product ? "error" : ""}
                        disabled={showInvalidCoupon !== false || loadingProducts}
                        value={request.product}
                    >
                        {
                            loadingProducts ?
                                <option disabled selected hidden value="0">
                                    Carregando...
                                </option> :
                                <option disabled selected hidden value="0">
                                    Produto
                                </option>
                        }
                        {
                            products &&
                            products.map(p =>
                                <option key={p.id} value={p.id}>
                                    {p.productName}
                                </option>)
                        }
                    </select>
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>
                <div className="form-group">
                    <select
                        id="sku"
                        onChange={eventValidation}
                        onFocus={eventValidation}
                        className={fieldsInvalid.product ? "error" : ""}
                        disabled={showInvalidCoupon !== false || !request.product}
                        value={request.sku}
                    >
                        {
                            loadingProducts ?
                                <option disabled selected hidden value="0">
                                    Carregando...
                                </option> :
                                <option disabled selected hidden value="0">
                                    Benefício
                                </option>
                        }
                        {
                            subProducts &&
                            subProducts.map(p =>
                                <option key={p.idSku} value={p.idSku}>
                                    {p.nomeSku}
                                </option>)
                        }
                    </select>
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>

                <Modal show={showConfirmModal} onHide={handleCancelSelection}
                    aria-labelledby="contained-modal-title-vcenter" centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontWeight: "bold" }}>Confirme a escolha do produto</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p style={{ fontSize: "10pt" }}>
                            Produto: <strong>{pendingProduct?.productName}</strong>
                        </p>
                        <p style={{ fontSize: "10pt", color: "#555" }}>Certifique-se que escolheu o produto prescrito pelo seu médico.</p>
                    </Modal.Body>


                    <Modal.Footer style={{ justifyContent: "center" }}>
                        <Button style={{ borderRadius: "2rem", border: "1.5px solid", fontSize: "10pt" }}
                            size="lg" variant="outline-primary"
                            onClick={handleCancelSelection}>Não, quero alterar
                        </Button>
                        <Button
                            style={{ borderRadius: "2rem", fontSize: "10pt" }}
                            size="lg" variant="primary"
                            onClick={handleConfirmSelection}>Sim, desejo seguir</Button>
                    </Modal.Footer>
                </Modal>

                <div className="form-group">
                    <MaskedInput
                        id="cpf"
                        type="text"
                        mask="111.111.111-11"
                        placeholderChar=" "
                        placeholder="CPF do paciente"
                        onChange={eventValidation}
                        onBlur={eventValidation}
                        className={fieldsInvalid.cpf ? "error" : ""}
                        disabled={showInvalidCoupon !== false}
                        value={resetForm ? "" : request.cpf}
                    />
                    {
                        errorMessageConsult &&
                        <span className="text-danger" style={{ fontSize: "14px", marginBottom: "20px" }}>
                            {errorMessageConsult}
                        </span>
                    }
                </div>
                <div className="form-group">
                    <MaskedInput
                        id="bornDate"
                        type="text"
                        mask="11/11/1111"
                        placeholderChar=" "
                        placeholder="Data de nascimento do paciente"
                        onChange={eventValidation}
                        onBlur={eventValidation}
                        className={fieldsInvalid.bornDate ? "error" : ""}
                        disabled={showInvalidCoupon !== false}
                        value={resetForm ? "" : request.bornDate}
                    />
                    {
                        errorMessageConsultFake &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {errorMessageConsultFake}
                        </span>
                    }
                </div>
                <div style={errorMessageYoungerAge ? { marginTop: '-10px', marginBottom: '10px' } : {}}>
                    {
                        errorMessageYoungerAge &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {errorMessageYoungerAge}
                        </span>
                    }
                </div>
                <div className="form-group">
                    <MaskedInput
                        id="cpfComprador"
                        type="text"
                        mask="111.111.111-11"
                        placeholderChar=" "
                        placeholder="CPF do comprador"
                        onChange={eventValidation}
                        onBlur={eventValidation}
                        className={fieldsInvalid.cpfComprador ? "error" : ""}
                        disabled={showInvalidCoupon !== false}
                        value={resetForm ? "" : request.cpfComprador}
                    />
                    {
                        errorMessageConsultBuyer &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {errorMessageConsultBuyer}
                        </span>
                    }
                </div>
                <div className="form-group">
                    <MaskedInput
                        id="bornDateComprador"
                        type="text"
                        mask="11/11/1111"
                        placeholderChar=" "
                        placeholder="Data de nascimento do comprador"
                        onChange={eventValidation}
                        onBlur={eventValidation}
                        className={fieldsInvalid.bornDateComprador ? "error" : ""}
                        disabled={showInvalidCoupon !== false}
                        value={resetForm ? "" : request.bornDateComprador}
                    />
                    {
                        errorMessageConsultFakeBuyer &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {errorMessageConsultFakeBuyer}
                        </span>
                    }
                </div>
                <div style={errorMessageYoungerAgeBuyer ? { marginTop: '-10px', marginBottom: '10px' } : {}}>
                    {
                        errorMessageYoungerAgeBuyer &&
                        <span className="text-danger" style={{ fontSize: "14px" }}>
                            {errorMessageYoungerAgeBuyer}
                        </span>
                    }
                </div>
                <div className="form-sc">
                    <div className="form-group form-select">
                        <select
                            id="crmState"
                            onChange={eventValidation}
                            onFocus={eventValidation}
                            className={fieldsInvalid.crmState || invalidPrescriber === true ? "error" : ""}
                            disabled={showInvalidCoupon !== false}
                            value={resetForm ? "0" : request.crmState}
                        >
                            <option disabled selected hidden value="0">UF</option>
                            {
                                states &&
                                states.map(state =>
                                    <option key={state.id} value={state.stateCode}>
                                        {state.stateCode}
                                    </option>)
                            }
                        </select>
                        <span className="arrow-down"><FaCaretDown /></span>
                    </div>
                    {
                        request.crmState == "RJ"
                            ? <div className="form-group input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">52</span>
                                <input
                                    id="crmNumber"
                                    type="text"
                                    placeholder="CRM do médico"
                                    onChange={eventValidation}
                                    onBlur={eventValidation}
                                    className={fieldsInvalid.crmNumber || invalidPrescriber === true ? "error" : ""}
                                    disabled={showInvalidCoupon !== false}
                                    value={resetForm ? "" : request.crmNumber}
                                />
                            </div>
                            : <div className="form-group">
                                <input
                                    id="crmNumber"
                                    type="text"
                                    placeholder="CRM do médico"
                                    onChange={eventValidation}
                                    onBlur={eventValidation}
                                    className={fieldsInvalid.crmNumber || invalidPrescriber === true ? "error" : ""}
                                    disabled={showInvalidCoupon !== false}
                                    value={resetForm ? "" : request.crmNumber}
                                />
                            </div>
                    }
                </div>
                <div className="form-check">
                    <input
                        id="agreeTerm"
                        type="checkbox"
                        onChange={eventValidation}
                        className={fieldsInvalid.agreeTerm ? "error" : ""}
                        disabled={showInvalidCoupon !== false}
                        checked={resetForm ? false : request.agreeTerm == 1}
                    />
                    <label htmlFor="agreeTerm">
                        Declaro que li e aceito os <a target="_blank" href="/REGULAMENTO_PRIMEIRA_DOSE.pdf"> termos de consentimento </a>
                    </label>
                </div>
                <div className="form-button">
                    <button
                        className="btn-primary"
                        disabled={showInvalidCoupon !== false || loading}
                    >
                        OK
                    </button>
                    {
                        showError &&
                        <div className="h4 text-danger">
                            <div
                                style={{
                                    wordBreak: 'break-word',
                                    width: window.innerWidth <= 1200 ? '200px' : '100%',
                                    whiteSpace: window.innerWidth < 1290 ? 'normal' : 'nowrap',
                                    overflowWrap: 'anywhere',
                                    marginLeft: '0'
                                }}
                            >
                                {errorMessage}
                            </div> <br />
                            Verifique os dados e tente novamente
                        </div>
                    }
                </div>
            </form>
            <CouponRegisterModal
                show={showSucess}
                onClick={() => setShowSucess(false)}
            />
            <SerasaRestrictionModal
                show={showSerasaRestriction}
                onHide={() => setShowSerasaRestriction(false)}
            />
            <Loading show={loading} />
        </div>
    );
};